import {FormattedMessage, useIntl} from "react-intl";
import {Helmet} from "react-helmet";

import {
  ContentWrapper,
  Heading,
  PageWrapper,
  Text,
  ButtonLink,
  CrunchyrollHorizontalSvg,
} from "@crunchyroll/cx-web-components";

import MinimalFooter from "../../components/footer/MinimalFooter/MinimalFooter";
import RouterLink from "../../components/link/RouterLink";

import {ASSETS_BUILD_PATH} from "../../constants/staticUrls";

import styles from "./notFound.module.scss";

const NotFound = () => {
  const intl = useIntl();

  return (
    <>
      <Helmet title={intl.formatMessage({id: "not_found.page_title"})} />
      <div className={styles.notFoundContainer}>
        <div className={styles.stickyHeader}>
          <div className={styles.headerContent}>
            <RouterLink to="/" data-t="home-btn" className={styles.headerLink}>
              <CrunchyrollHorizontalSvg
                className={styles.staticLogoIcon}
                isReadable
              />
            </RouterLink>
          </div>
        </div>
        <PageWrapper className={styles.pageWrapper}>
          <ContentWrapper className={styles.contentWrapper}>
            <img
              className={styles.yuzuBucketImg}
              src={`${ASSETS_BUILD_PATH}/img/yuzu-bucket.png`}
              alt={intl.formatMessage({id: "alt.yuzu"})}
            />
            <div className={styles.exceptionErrorContent}>
              <Heading as="h3" size="l">
                <FormattedMessage id="not_found.page_not_found_title" />
              </Heading>
              <Text as="p" className={styles.errorText} size="xl">
                <FormattedMessage id="not_found.page_not_found_description" />
              </Text>
              <ButtonLink
                to="/"
                data-t="home-btn"
                className={styles.homeButton}
              >
                <FormattedMessage id="not_found.take_home_btn" />
              </ButtonLink>
            </div>
          </ContentWrapper>
        </PageWrapper>
        <div>
          <MinimalFooter />
        </div>
      </div>
    </>
  );
};

export default NotFound;
